
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repricer",
      function () {
        return require("private-next-pages/repricer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repricer"])
      });
    }
  